import { createSlice } from '@reduxjs/toolkit';
import { getJobStates } from 'ducks/job-states-list/operators';
import { normalizeJobStates } from 'ducks/job-states-list/utils';
import { Slices } from 'ducks/slices';

export type JobStatesListState = ReturnType<typeof normalizeJobStates>;

const initialState: JobStatesListState = [];

const jobStatesListSlice = createSlice({
  name: Slices.JOB_STATES_LIST,
  initialState,
  reducers: {
    clearJobStatesList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobStates.pending, () => {
        return initialState;
      })
      .addCase(getJobStates.fulfilled, (_, { payload }) => {
        return normalizeJobStates(payload);
      })
      .addCase(getJobStates.rejected, () => {
        return initialState;
      });
  },
});

export const { clearJobStatesList } = jobStatesListSlice.actions;

export default jobStatesListSlice.reducer;
